type AngleUpIconProps = {
  colorClass: string;
  width?: string;
  height?: string;
};

export const AngleUpIcon = ({
  colorClass,
  width = "15",
  height = "9",
}: AngleUpIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 9"
  >
    <path
      data-name="Tracé 11374"
      d="M6.3 7.5.359 13.179a1 1 0 0 0-.357.83 1.01 1.01 0 0 0 .469.777 1.218 1.218 0 0 0 1.513-.107L8.655 8.25a.988.988 0 0 0 0-1.5L1.985.321A1.218 1.218 0 0 0 .471.214 1.01 1.01 0 0 0 0 .991a1 1 0 0 0 .357.83z"
      transform="rotate(-90 4.5 4.5)"
      className={colorClass}
    />
  </svg>
);
